import {
    MenuCategoryDto,
    MenuEntryCreateDto,
    MenuEntryUpdateDto,
    PriceCreateDto, PriceDto,
    PriceUpdateDto
} from "../../../api";
import MenuEntryModalForm from "../menuEntryModalForm/menuEntryModalForm";

export default function MenuEntryModalFormAddContainer(props: MenuEntryModalFormAddContainerProps) {
    return <>
        <MenuEntryModalForm
            isModalVisible={props.addFormVisibility}
            setModalVisibility={props.onFinish}
            onSubmit={props.onSubmit}
            onPriceSubmit={props.onPriceSubmit}
            onPriceEdit={props.onPriceEdit}
            modalTitle={props.title}
            saveButtonTitle="Zapisz"
            cancelButtonTitle="Anuluj"
            initialValues={props.MenuEntryToEdit!}
            menuCategories={props.menuCategories}
            onPriceDelete={props.onPriceDelete}
        />
    </>
}

interface MenuEntryModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    onSubmit: (values: MenuEntryCreateDto | MenuEntryUpdateDto) => Promise<any>,
    onPriceSubmit: (values: PriceCreateDto | PriceUpdateDto) => void,
    onPriceEdit: (values: PriceUpdateDto[]) => void,
    addFormVisibility: boolean,
    title: string,
    MenuEntryToEdit: MenuEntryUpdateDto | null,
    menuCategories: MenuCategoryDto[] | null,
    onPriceDelete: (record: PriceDto) => void;
}
